(function () {
  "use strict";

    AdvancedTierTrialCtrl.$inject = ['$scope', 'accountService', '$window'];
  angular
    .module('trainerWebApp.modals')
    .controller('AdvancedTierTrialCtrl', AdvancedTierTrialCtrl);

  function AdvancedTierTrialCtrl($scope, accountService, $window) {

      $scope.modal = {
        content: 0,
        data: {},
        status: 'saving',
        confirmed:true
      };

      $scope.close = function() {
        $window.document.location.reload();
      };

      $scope.$on('advancedTierTrialRequestedEvent', function(event) {
        $scope.modal.status = 'saving';
        $scope.modal.data = {};
        $scope.modal.content = '';
        $scope.modal.confirmed = true;
        $scope.show();

        function cb(res) {
          // show info about advanced features
          $scope.modal.status = '';
          $scope.modal.data = {};
          $scope.modal.content = '';
          $scope.modal.confirmed = false;
        }

        function errorCb(err) {
          $scope.dismiss();
        }

        accountService.enableAdvancedTierTrial({}, cb, errorCb);
      });

    }

})();
